import { Button } from '@mui/material'
import { useRouter } from 'next/router'
export const SignUpButton = (props) => {
  const router = useRouter()
  return (
    <Button
      onClick={() => {
        router.push('/sign-up')
      }}
      variant='text'
      data-testid='SignUpButton'
      color='inherit'
      {...props}
    >
      Sign up for free
    </Button>
  )
}
